module.exports = __webpack_public_path__ + "img/2021AllotteeOthersTiktok.1395ad0a.jpg";